import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { Button } from "@/components/ui/button";

export function NotFoundPage() {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col items-center justify-center py-24 text-center">
      <h1 className="text-4xl font-semibold">404</h1>
      <p className="text-muted-foreground mt-2 mb-6">
        {t("page.notFound.description")}
      </p>
      <Button asChild>
        <Link to="/">{t("page.notFound.goHome")}</Link>
      </Button>
    </div>
  );
}
